export default "__VITE_ASSET__c26cbbe5__"